export function websiteConfirmation(value, at) {
  const kind = { confirmed: { label: 'Confirmed on WhatsApp', color: 'success' }, not_me: { label: 'Customer: not me', color: 'warning' } }[value];
  if (!kind) return null;
  const date = at ? new Date(at) : null;
  return { ...kind, time: date && Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', dateStyle: 'medium', timeStyle: 'medium', hour12: false }).format(date) + ' (Dubai)' : null };
}

// Contact provenance is informational; never infer a mismatch from phone values.
export function websiteContactMismatch(query) {
  if (query?.website_contact_mismatch !== true) return null;
  return {
    label: 'Messaged from a different number',
    tooltip: `Form number ends ${query.website_submitted_phone_last4 ?? 'unknown'}; WhatsApp from ${query.website_sender_phone_last4 ?? 'unknown'}`,
  };
}

export function websiteConfirmationTooltip(query) {
  const state = websiteConfirmation(query?.website_confirmation, query?.website_confirmation_at);
  if (!state) return null;
  return [state.time, query?.website_confirmation_match_method === 'reference_message' ? 'Confirmed by message' : null].filter(Boolean).join(' · ') || null;
}
